<template>
  <VDropdown ref="dropdown" label="Fill from registration">
    <div class="bg-white w-96 rounded py-2 shadow-md">
      <ul class="py-1">
        <li
          v-for="option in options"
          :key="option.id"
          class="px-2 py-3 sm:px-4 group hover:bg-gray-100 cursor-pointer"
          @click="selectOption(option)"
        >
          <h2
            v-if="option.businessName"
            v-text="option.businessName"
            class="text-base text-gray-800"
          />
          <h3
            v-if="option.businessAddress"
            v-text="option.businessAddress"
            class="text-sm font-normal text-gray-800"
          />
          <h3 v-if="option.number || option.office" class="text-sm font-normal text-gray-800">
            {{ getNumberAndOfficeLabel(option) }}
          </h3>
        </li>
      </ul>
    </div>
  </VDropdown>
</template>

<script>
import VDropdown from 'Components/Common/VDropdown.vue';

export default {
  components: {
    VDropdown,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getNumberAndOfficeLabel({ number, office }) {
      return [number, office].filter((x) => x).join(' - ');
    },
    selectOption(option) {
      this.$emit('select', option);
      this.$refs.dropdown.closeMenu();
    },
  },
};
</script>
